import { render, staticRenderFns } from "./rent_price.vue?vue&type=template&id=08483dc8"
import script from "./rent_price.vue?vue&type=script&lang=js"
export * from "./rent_price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports